var styles = {"container":"AppLink-module_container__2qATQ","content":"AppLink-module_content__3Mu3M","link":"AppLink-module_link__K62RT"};

export { styles as default };
//# sourceMappingURL=AppLink.module.css.js.map
